import React, { useState, useEffect } from "react";
import { Checkbox, IconArrowDropDown } from "cdk-radial";
import {
  AMPLITUDE_EVENTS,
  AMPLITUDE_PROPERTIES,
} from "../../../../utils/AmplitudeConstants";
import { SHOW_LESS, SHOW_MORE } from "../../constants";
import { API_DIRECTORY_THEME } from "../../../../utils/constants";
import { useAPIDirectoryHomeContext } from "../../../../contexts/APIHomeDirectoryContext";

export const ApiSearchGroupItem = ({
  keyId,
  searchParams,
  searchKey,
  selectedFilters,
  setSearchFilters,
  sendAmplitudeData,
  apiHomeOnClickHandlers,
  belongsTo,
}) => {
  const { auth } = useAPIDirectoryHomeContext();
  const [searchExpander, setSearchExpander] = useState(true);
  const [selectedSearchItems, setSelectedSearchItems] = useState({});
  const [searchData, setSearchData] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const { name: userName, email: userEmail } = auth?.userData || {};
  const { id: orgId, name: orgName } = auth?.orgData || {};

  const filteredData = searchData.filter((f) => f.searchKey === searchKey);
  const itemsToDisplay = showAll ? filteredData : filteredData.slice(0, 7);

  useEffect(() => {
    if (!!searchKey && searchParams?.values?.length > 0) {
      const locSearchData = [];
      searchParams.values.forEach((f) => {
        locSearchData.push({
          label: f.value,
          name: f.key,
          searchKey: searchKey,
        });
      });

      setSearchData(locSearchData);
    }
  }, [searchParams, searchKey]);

  useEffect(() => {
    const selectedFilterType = selectedFilters;

    if (
      !!searchKey &&
      !!selectedFilterType &&
      Array.isArray(selectedFilterType) &&
      searchParams?.values?.length > 0
    ) {
      let locSelectedFilters = {};
      let preSelectedFilters = {};

      selectedFilterType.forEach((ftr) => {
        let locfilter = "";
        if (searchKey === "apiType") {
          locfilter = searchParams.values.find((f) => f.value === ftr);
        } else {
          locfilter = searchParams.values.find((f) => f.key === ftr);
        }

        if (!!locfilter) {
          locSelectedFilters = {
            ...locSelectedFilters,
            [locfilter["key"]]: true,
          };
        }
      });

      searchData.forEach((sd) => {
        if (!!selectedSearchItems[sd.name]) {
          preSelectedFilters = { ...preSelectedFilters, [sd.name]: false };
        }
      });

      const locSelectedSearchItems = {
        ...selectedSearchItems,
        ...preSelectedFilters,
        ...locSelectedFilters,
      };

      const locSearchItems = {
        ...preSelectedFilters,
        ...locSelectedFilters,
      };

      if (
        JSON.stringify(locSelectedSearchItems) !==
        JSON.stringify(selectedSearchItems)
      ) {
        setSelectedSearchItems(locSearchItems);
        setSearchFilters({
          [searchKey]: locSearchItems,
        });
      }
    }
  }, [selectedFilters, searchParams]);

  const handleExpanderClick = (_) => {
    setSearchExpander(!searchExpander);
  };

  const getFilterText = (filterText) => {
    if (filterText.length > 20) {
      return `${filterText.substring(0, 17)}...`;
    } else {
      return filterText;
    }
  };

  const getCheckedStatus = (key) => {
    return !!Object.keys(selectedSearchItems).find(
      (f) => f === key && !!selectedSearchItems[f]
    );
  };

  const handleSearchItemClick = (e, itemKey) => {
    e.preventDefault();
    const updatedSelection = {
      ...selectedSearchItems,
      [itemKey]: !e.target.checked,
    };

    setSelectedSearchItems(updatedSelection);
    setSearchFilters({
      [searchKey]: {
        [itemKey]: !e.target.checked,
      },
    });
    if (belongsTo === API_DIRECTORY_THEME.ISV_API_DIRECTORY) {
      apiHomeOnClickHandlers.handleFiltersRedirection({
        searchKey: searchKey,
        itemKey: itemKey,
      });
    }
    if (belongsTo === API_DIRECTORY_THEME.DEALER_API_DIRECTORY) {
      apiHomeOnClickHandlers.handleDealerFiltersRedirection({
        searchKey: searchKey,
        itemKey: itemKey,
      });
    }

    if (belongsTo === API_DIRECTORY_THEME.ISV_API_DIRECTORY)
    sendAmplitudeData(AMPLITUDE_EVENTS.FILTERING_APIS, {
      [AMPLITUDE_PROPERTIES.SELECTED_FIELDS]: {
        [AMPLITUDE_PROPERTIES.FILTER_TYPE]: itemKey || "",
        [AMPLITUDE_PROPERTIES.IS_SELECTED]: !e.target.checked,
      },
    });
    if(belongsTo === API_DIRECTORY_THEME.DEALER_API_DIRECTORY) {
      sendAmplitudeData(AMPLITUDE_EVENTS.DEALER_API_DIRECTORY_FILTER_BY, {
        [AMPLITUDE_PROPERTIES.USER_ID]: userEmail || "",
        [AMPLITUDE_PROPERTIES.USER_NAME]: userName || "",
        [AMPLITUDE_PROPERTIES.ORG_ID]: orgId || "",
        [AMPLITUDE_PROPERTIES.ORG_NAME]: orgName || ""
      });
    }
  };

  return (
    <>
      <div className="api-dir-pkg_search-group-item">
        {searchParams?.values?.length > 0 && (
          <div
            className="api-search-block"
            onClick={handleExpanderClick.bind(this)}
          >
            <li key={keyId}>{searchParams.text}</li>
            <div
              className={
                searchExpander ? "api-dir-pkg_search-group-expander-down" : ""
              }
            >
              <IconArrowDropDown />
            </div>
          </div>
        )}
        {searchExpander && (
          <div className="api-dir-pkg_search-group-item-param">
            <ul className="api-dir-pkg_search-filter-group-items">
              {itemsToDisplay.map((sd, idx) => (
                <li
                  key={idx}
                  className="api-dir-pkg_search-filter-group-item-wrapper"
                >
                  <Checkbox
                    name={`searchData-${idx}`}
                    checked={getCheckedStatus(sd.name)}
                    label=""
                    hideLabel
                    onChange={() => {}}
                    onClick={(e) => handleSearchItemClick(e, sd.name)}
                  />
                  <div className="api-dir-pkg_search-filter-group-item">
                    {sd.label.length > 20 ? (
                      <span>{getFilterText(sd.label)}</span>
                    ) : (
                      sd.label
                    )}
                  </div>
                </li>
              ))}

              {filteredData.length > 7 && (
                <li className="api-dir-pkg_search-filter-group-item-wrapper">
                  <a
                    className="api-dir-pkg_show-more-section"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowAll(!showAll);
                    }}
                  >
                    {showAll ? SHOW_LESS : SHOW_MORE}
                  </a>
                </li>
              )}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};
